// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__1ToCv","red":"Badge_red__21Vi_","orange":"Badge_orange__3PwbK","gray":"Badge_gray__2JePf"};